import { type FunctionComponent } from 'react';
import { IconWrapper } from '../style';
import type { IconProps } from '../types';

export const FilterIcon: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      transform={`rotate(${rotation ?? 0})`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1357 16.8518V12.5493L18.5483 5.84975C18.6755 5.69237 18.5679 5.4519 18.3704 5.45182H5.62951C5.43218 5.45204 5.32456 5.69242 5.45157 5.84975L10.8116 12.4841V18.3036C10.8117 18.5029 11.0306 18.617 11.1838 18.4974L13.0431 17.0456C13.1016 16.9999 13.1356 16.9279 13.1357 16.8518ZM14.5301 16.8518C14.5301 17.3849 14.2888 17.8864 13.8792 18.2063L12.0199 19.6581C10.9475 20.4955 9.4172 19.6993 9.4171 18.3036V13.0134L4.38484 6.7836C3.49509 5.68188 4.24699 4.00023 5.62951 4H18.3704C19.7531 4.00008 20.505 5.68183 19.6151 6.7836L14.5301 13.0786V16.8518Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  </IconWrapper>
);
